<template>
  <form>
    <v-list v-if="!classData.students">
      <v-skeleton-loader class="mx-auto" type="list-item-avatar-two-line"></v-skeleton-loader>
      <v-skeleton-loader class="mx-auto" type="list-item-avatar-two-line"></v-skeleton-loader>
      <v-skeleton-loader class="mx-auto" type="list-item-avatar-two-line"></v-skeleton-loader>
      <v-skeleton-loader class="mx-auto" type="list-item-avatar-two-line"></v-skeleton-loader>
    </v-list>

    <div v-else class="px-2">
      <v-row
        style="border-bottom: 1px solid #eeeeee"
        class="align-center"
        v-for="(item, index) in data"
        :key="index"
      >
        <v-col cols="6" md="4">
          <div class="d-flex align-center">
            <div class="mr-6">
              {{ index + 1 }}
            </div>
            <card-student-name :student="item.student"></card-student-name>
          </div>
        </v-col>
        <v-col cols="6" md="7">
          <v-radio-group
            style="justify-content: space-around; align-items: start"
            v-model="item.attendance"
            :ripple="false"
            :row="$vuetify.breakpoint.mdAndUp"
            :class="{ 'mt-0': $vuetify.breakpoint.smAndDown }"
          >
            <v-radio color="green" label="Có Mặt" value="attendance"></v-radio>
            <v-radio
              :class="{ 'mr-5': !$vuetify.breakpoint.smAndDown }"
              color="red"
              label="Vắng"
              value="absent"
            ></v-radio>
            <v-radio
              :class="{ 'mr-5': !$vuetify.breakpoint.smAndDown }"
              color="orange"
              label="Vắng (Có Phép)"
              value="approved-absent"
            ></v-radio>
            <v-radio
              :class="{ 'mr-5': !$vuetify.breakpoint.smAndDown }"
              color="yellow"
              label="Đi Muộn"
              value="late"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
    </div>
  </form>
</template>

<script>
import CardStudentName from '@/components/basic/card/CardStudentImage.vue'
import { mapActions, mapState } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
export default {
  components: {
    CardStudentName
  },
  props: {
    slotData: {
      type: [Object],
      required: true,
      default: () => {}
    },
    classData: {
      type: [Object],
      required: true,
      default: () => {}
    },
    attendances: {
      type: [Object],
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    data: [
      {
        student: {},
        slot: {},
        attendance: ''
      }
    ]
  }),
  created() {
    this.refresh()
  },
  computed: {
    ...mapState('app', ['department'])
  },
  methods: {
    ...mapActions('classDetail', ['createAttendance']),
    refresh() {
      this.data = [
        ...this.slotData.teachers.map(student => {
          const attendance = _.get(this.attendances, `${this.slotData.id + student.id}.status`, '')
          return {
            student,
            type: 'teacher-attendance',
            slot: this.slotData,
            attendance
          }
        }),
        ...this.slotData.mentors.map(student => {
          return {
            student,
            type: 'mentor-attendance',
            slot: this.slotData,
            attendance: _.get(this.attendances, `${this.slotData.id + student.id}.status`, '')
          }
        }),
        ...this.classData.students.map(student => {
          return {
            student,
            type: 'student-attendance',
            slot: this.slotData,
            attendance: _.get(this.attendances, `${this.slotData.id + student.id}.status`, '')
          }
        })
      ]
    },
    getData() {
      return this.data.map(att => ({
        slot: this.slotData.id,
        slotType: this.slotData.type,
        date: this.slotData.startTime,
        duration: moment
          .duration(moment(this.slotData.endTime).diff(this.slotData.startTime))
          .asHours(),
        student: att.type === 'student-attendance' ? att.student.id : null,
        teacher: att.type === 'teacher-attendance' ? att.student.id : null,
        mentor: att.type === 'mentor-attendance' ? att.student.id : null,
        userId: att.student.id,
        class: this.classData.id,
        course: _.get(this.classData, 'course.id'),
        department: _.get(this.classData, 'department.id,'),
        status: att.attendance,
        type: att.type
      }))
    }
  },
  watch: {
    async slotData(slotData) {
      this.refresh()
    }
  }
}
</script>

<style>
.v-input--radio-group__input {
  justify-content: space-around;
}
</style>
